module.exports = __webpack_public_path__ + "files/7bededb15fbecd40d230bd6b13894a0c.png";